/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} TimesheetModificationsViewModelType
 * @property {string} startTime - New start time
 * @property {string} endTime - New end time
 * @property {string} unpaidBreakMinutes
 * @property {TimesheetModificationDetailsViewModel[]} changes
 */

import TimesheetModificationDetailsViewModel from './timesheetModificationDetailsViewModel'

/**
 * @class
 */
export default class TimesheetModificationsViewModel {
  /**
   * Create a new TimesheetModificationsViewModel.
   * @param {TimesheetModificationsViewModelType} params
   */
  constructor(params) {
    this.startTime = params.startTime
    this.endTime = params.endTime
    this.unpaidBreakMinutes = params.unpaidBreakMinutes
    this.changes =
      params.changes && params.changes.length > 0
        ? params.changes.map(
            (change) => new TimesheetModificationDetailsViewModel(change)
          )
        : []
  }
}
